
export const string = {
  truncate: function(str, length, truncation) {
    if (str) {
      length = length || 30
      truncation = typeof truncation === "string" ? truncation : "..."
      return str.length > length ? str.slice(0, length - truncation.length) + truncation : String(str)
    }
    else
    {
      return '';
    }
  },
  isNull: function (value) {
    if (typeof(value) == "undefined"){
      return true;
    }
    return false;
  }
};

export function toBookCover(id) {
  window.location.href = '/book/' + id + ''
}

export function toBookRead(bookid,chapterid) {
  window.location.href = '/read/' + bookid + '/' + chapterid
}

export function toRecharge(id) {
  window.location.href = '/recharge'
}

export function toRegist() {
  window.location.href = '/regist'
}

